import React, { Fragment } from 'react';
import * as Yup from 'yup';
import NumberFormat from 'react-number-format';

import { makeStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';

import {
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    Box,
    Grid,
    colors,
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Button,
    TextField,
    Switch,
    Avatar
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    avatar: {
        marginRight: theme.spacing(2),
        marginTop: theme.spacing(2),
        color: colors.cyan[300],
        backgroundColor: colors.grey[200],
        width: 290,
        height: 290
    }
}));

const CreateLPU = ({ item, open, closeCreation, createValues, dependencies }) => {

    const classes = useStyles();

    const changeValor = (event, value) => {
        value.valor = event.target.value
    }

    const changeInstalacao = (event, value) => {
        value.instalacao = event.target.value
    }

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="md" className={classes.root} >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Produto
                    </Typography>
                </DialogTitle>

                <DialogContent dividers={true}>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                nome: Yup.string().required('O nome da unidade é obrigatório'),
                                APLICACAO: Yup.string().required('A categoria do produto é obrigatória'),
                                UNIDADE: Yup.string().required('A Unidade do produto é obrigatória'),
                            }
                            )
                        }
                        onSubmit={(values, formik) => {
                            createValues(values);
                            formik.setSubmitting(false);
                        }}

                    >

                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>

                                <Grid
                                    container
                                    xs="auto"
                                    spacing={2}
                                >

                                    <Grid
                                        item
                                        md={2}
                                        xs={12}>

                                        <TextField
                                            error={Boolean(touched.codigo && errors.codigo)}
                                            fullWidth
                                            label="Código"
                                            margin="none"
                                            name="codigo"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.codigo}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={
                                                { readOnly: false, }
                                            }

                                        />

                                    </Grid>


                                    <Grid
                                        item
                                        md={4}
                                        xs={12}>

                                        <FormControl variant="outlined" fullWidth>
                                            <InputLabel shrink required htmlFor="APLICACAO">Categoria</InputLabel>
                                            <Select notched
                                                required
                                                autosize={true}
                                                error={Boolean(touched.APLICACAO && errors.APLICACAO)}
                                                value={values.APLICACAO}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                label="Categoria"
                                                variant="outlined"
                                                inputProps={{
                                                    name: 'APLICACAO',
                                                    id: 'APLICACAO',
                                                }}
                                            >
                                                <MenuItem value={null}>
                                                    <em>Selecione uma das opções abaixo</em>
                                                </MenuItem>
                                                {dependencies.applications.map((regiao) => (
                                                    <MenuItem key={regiao.id} value={regiao.id}>{regiao.nome}</MenuItem>
                                                ))}

                                            </Select>
                                        </FormControl>

                                    </Grid>


                                    <Grid
                                        item
                                        md={4}
                                        xs={12}>

                                        <FormControl variant="outlined" fullWidth>
                                            <InputLabel shrink htmlFor="UNIDADE" required>Unidade</InputLabel>
                                            <Select notched
                                                autosize={true}
                                                required
                                                error={Boolean(touched.UNIDADE && errors.UNIDADE)}
                                                helperText={touched.UNIDADE && errors.UNIDADE}
                                                value={values.UNIDADE}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                label="Unidade"
                                                variant="outlined"
                                                inputProps={{
                                                    name: 'UNIDADE',
                                                    id: 'UNIDADE',
                                                }}
                                            >
                                                <MenuItem value={null}>
                                                    <em>Selecione uma das opções abaixo</em>
                                                </MenuItem>
                                                {dependencies.units.map((unit) => (
                                                    <MenuItem key={unit.id} value={unit.id}>{unit.nome}</MenuItem>
                                                ))}

                                            </Select>
                                        </FormControl>

                                    </Grid>

                                    <Grid
                                        item
                                        md={2}
                                        xs="auto">
                                        <Typography
                                            color="textPrimary"
                                            gutterBottom
                                            variant="h6"
                                        >
                                            Ativo
                                        </Typography>
                                        <Switch
                                            checked={values.ativo}
                                            onChange={handleChange}
                                            name="ativo"
                                            id="ativo" />
                                    </Grid>

                                    <Grid
                                        item
                                        md={12}
                                        xs={12}>

                                        <TextField
                                            error={Boolean(touched.nome && errors.nome)}
                                            required
                                            fullWidth
                                            label="Nome"
                                            rows={2}
                                            size={10}
                                            length={512}
                                            multiline
                                            margin="none"
                                            name="nome"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.nome}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}

                                        />

                                    </Grid>


                                    <Grid
                                        item
                                        md={12}
                                        xs={12}
                                    >
                                        <TextField
                                            error={Boolean(touched.consideracoes && errors.consideracoes)}
                                            fullWidth
                                            label="Observações Sobre o Produto"
                                            rows={2}
                                            size={10}
                                            length={512}
                                            multiline
                                            margin="none"
                                            name="consideracoes"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.consideracoes}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>


                                    <Grid
                                        item
                                        md={12}
                                        xs={12}>
                                        <Divider></Divider>
                                    </Grid>

                                    <Grid
                                        item
                                        md="auto"
                                        xs={12}>
                                        <Grid
                                            container
                                            xs="auto"
                                            spacing={2}
                                        >
                                            {dependencies.regions.map((regiao) => (

                                                values.valores.map((valor) => (
                                                    (valor.regiao == regiao.id) ? (
                                                        <Fragment>

                                                            <Grid
                                                                item
                                                                md={5}
                                                                xs={12}>

                                                                <TextField
                                                                    fullWidth
                                                                    required
                                                                    label="Região"
                                                                    margin="none"
                                                                    name="regiao.nome"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    value={regiao.nome}
                                                                    variant="outlined"
                                                                    InputLabelProps={{ shrink: true }}
                                                                    inputProps={
                                                                        { readOnly: true, }
                                                                    }

                                                                />

                                                            </Grid>


                                                            <Grid
                                                                item
                                                                md={3}
                                                                xs={12}>
                                                                <NumberFormat
                                                                    fullWidth
                                                                    required
                                                                    label="Valor Material"
                                                                    margin="none"
                                                                    onBlur={handleBlur}
                                                                    value={valor.valor}
                                                                    onChange={e => {
                                                                        changeValor(e, valor);
                                                                        handleChange(e);
                                                                    }}
                                                                    variant="outlined"
                                                                    decimalScale="2"
                                                                    fixedDecimalScale="true"
                                                                    customInput={TextField}
                                                                    InputLabelProps={{ shrink: true }}
                                                                />

                                                            </Grid>

                                                            <Grid
                                                                item
                                                                md={3}
                                                                xs={12}>

                                                                <NumberFormat
                                                                    error={Boolean(touched.instalacao && errors.instalacao)}
                                                                    required
                                                                    fullWidth
                                                                    label="Valor Instalação"
                                                                    margin="none"
                                                                    onBlur={handleBlur}
                                                                    onChange={e => {
                                                                        changeInstalacao(e, valor);
                                                                        handleChange(e);
                                                                    }}
                                                                    value={valor.instalacao}
                                                                    variant="outlined"
                                                                    decimalScale="2"
                                                                    fixedDecimalScale="true"
                                                                    customInput={TextField}
                                                                    InputLabelProps={{ shrink: true }}
                                                                />

                                                            </Grid>
                                                        </Fragment>
                                                    ) : ("")

                                                ))
                                            ))}
                                        </Grid>
                                    </Grid>

                                </Grid>


                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justifyContent="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeCreation() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default CreateLPU;
